module.exports = __webpack_public_path__ + "static/workshop2-3bd1b17f0b5e8d85e44105bfb05e09b5.jpg";